import { Component, OnInit, Input } from '@angular/core';
import { EventsService } from '@app/_shared';
import { AuthService, AuthRole } from '@app/modules/auth';
import { CustomEvents } from '@app/_helpers';
import { AffiliateService } from '@app/modules/affiliate/providers/affiliate.service';
import { MbPlansService } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.service';

@Component({
    selector: 'app-display-picture',
    templateUrl: './display-picture.component.html',
    styleUrls: ['./display-picture.component.scss']
})
export class DisplayPictureComponent implements OnInit {
    picture = '';
    full_name = 'GuestUser'; // Default name if not available
    @Input('size') size: number;

    constructor(
        private eventsService: EventsService,
        private mbPlansService: MbPlansService,
        private authService: AuthService,
        private affiliateService: AffiliateService
    ) {
        if ((this.authService.accessTokenObj?.role === AuthRole.SUPERDEALER) || (this.authService.accessTokenObj?.role === AuthRole.BUSINESSPARTNER)) {
            this.affiliateService.getAffiliateProfile().subscribe(res => {
                if (res) {
                    if (res.image) {
                        this.picture = res.image;
                    }
                    this.full_name = res.full_name;
                }
            })
        } else if (this.authService.accessTokenObj?.role !== AuthRole.ADMIN) { //Default will be user
            this.refreshPersonalDetails(true);
        } else {
            this.full_name = "Admin";
            this.picture = "/assets/uTradeAlgos.jpg";
        }

        this.eventsService.subscribe(CustomEvents.ImageUpdated, (image) => {
            this.picture = image;
        });
        this.eventsService.subscribe(CustomEvents.ProfileUpdated, () => {
            this.refreshPersonalDetails(true);
        });
    }

    ngOnInit(): void {
    }

    private refreshPersonalDetails(update = false) {
        this.mbPlansService.getUserDetails(update).subscribe((response) => {
            if (response) {
                if(response.full_name.trim() !== '') {
                    this.full_name = response.full_name;
                }
                if (response.image || response.image_link) {
                    this.picture = response.image || response.image_link;
                }
            }
        });
    }
}
